export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12591.b2bbe9b6.jpg";